export class CaseReviewModal {
  private element: HTMLElement;

  constructor(
    private readonly apiBaseUrl: string,
    private readonly userRole: string,
    private readonly agencyId: string | undefined,
    private readonly onClose: () => void
  ) {
    this.element = document.createElement('div');
    this.element.className = 'modal-backdrop';
  }

  public async mount(container: HTMLElement): Promise<void> {
    this.render();
    container.appendChild(this.element);
    await this.loadMetrics();
    await this.loadCases();
  }

  private render(): void {
    this.element.innerHTML = `
      <div class="modal-card" style="max-width: 1100px; width: 95%; max-height: 90vh; display: flex; flex-direction: column;">
        <div class="modal-header">
          <div style="display:flex; align-items:center; gap:10px;">
            <div style="background:rgba(59,130,246,0.15); border:1px solid rgba(59,130,246,0.4); color:#60a5fa; padding:8px; border-radius:8px;">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
            </div>
            <div>
              <h3 style="font-size:1.15rem; font-weight:700; color:#fff; margin:0;">Centro de Supervisión y Consulta de Casos CAD / 911</h3>
              <p style="font-size:0.8rem; color:var(--text-muted); margin:0;">Rol activo: <strong>${this.userRole}</strong> • Auditoría Forense, Video, Chat y Ruta GPS</p>
            </div>
          </div>
          <button id="btn-close-cases-modal" class="btn-ghost" style="padding:6px 12px; border-radius:50%;">✕</button>
        </div>

        <!-- Tarjetas de Métricas Ejecutivas -->
        <div id="metrics-bar" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)); gap: 10px; margin-top: 14px;">
          <div style="background:rgba(255,255,255,0.03); border:1px solid var(--border-dim); padding:10px; border-radius:8px;">
            <div style="font-size:0.75rem; color:var(--text-muted);">TOTAL LLAMADAS</div>
            <div id="metric-total-sessions" style="font-size:1.2rem; font-weight:700; color:#38bdf8;">--</div>
          </div>
          <div style="background:rgba(255,255,255,0.03); border:1px solid var(--border-dim); padding:10px; border-radius:8px;">
            <div style="font-size:0.75rem; color:var(--text-muted);">COMPLETADAS</div>
            <div id="metric-completed-sessions" style="font-size:1.2rem; font-weight:700; color:#34d399;">--</div>
          </div>
          <div style="background:rgba(255,255,255,0.03); border:1px solid var(--border-dim); padding:10px; border-radius:8px;">
            <div style="font-size:0.75rem; color:var(--text-muted);">VIDEOS FORENSES</div>
            <div id="metric-total-recs" style="font-size:1.2rem; font-weight:700; color:#f59e0b;">--</div>
          </div>
          <div style="background:rgba(255,255,255,0.03); border:1px solid var(--border-dim); padding:10px; border-radius:8px;">
            <div style="font-size:0.75rem; color:var(--text-muted);">ESPACIO OCUPADO</div>
            <div id="metric-total-storage" style="font-size:1.2rem; font-weight:700; color:#a78bfa;">-- MB</div>
          </div>
          <div style="background:rgba(255,255,255,0.03); border:1px solid var(--border-dim); padding:10px; border-radius:8px;">
            <div style="font-size:0.75rem; color:var(--text-muted);">PINGS GPS TOTALES</div>
            <div id="metric-total-gps" style="font-size:1.2rem; font-weight:700; color:#ec4899;">--</div>
          </div>
        </div>

        <!-- Filtros de Fecha y Exportación CSV -->
        <div style="display:flex; justify-content:space-between; align-items:center; flex-wrap:wrap; gap:10px; margin-top:12px; background:rgba(255,255,255,0.02); border:1px solid var(--border-dim); padding:10px 14px; border-radius:8px;">
          <div style="display:flex; align-items:center; gap:8px; font-size:0.8rem;">
            <span style="color:var(--text-muted); font-weight:700;">Filtrar por Fecha:</span>
            <input type="date" id="filter-date-start" class="form-input" style="height:32px; padding:4px 8px; font-size:0.8rem;" />
            <span style="color:var(--text-muted);">-</span>
            <input type="date" id="filter-date-end" class="form-input" style="height:32px; padding:4px 8px; font-size:0.8rem;" />
            <button id="btn-apply-date-filter" class="btn-ghost" style="padding:4px 10px; font-size:0.75rem; border:1px solid #475569;">Filtrar</button>
            <button id="btn-clear-date-filter" class="btn-ghost" style="padding:4px 10px; font-size:0.75rem; color:#94a3b8;">Limpiar</button>
          </div>

          <button id="btn-export-csv" class="btn-primary" style="background:#0284c7; border-color:#0284c7; padding:6px 14px; font-size:0.8rem; display:inline-flex; align-items:center; gap:6px;">
            📊 Exportar Reporte (CSV)
          </button>
        </div>

        <!-- Contenedor Dividido: Lista de Casos y Detalle Forense -->
        <div style="display: grid; grid-template-columns: 360px 1fr; gap: 16px; margin-top: 14px; flex: 1; min-height: 0; overflow: hidden;">
          
          <!-- Lista de Casos -->
          <div style="display:flex; flex-direction:column; border:1px solid var(--border-dim); border-radius:8px; background:rgba(15,23,42,0.4); overflow:hidden;">
            <div style="padding:10px; border-bottom:1px solid var(--border-dim); display:flex; gap:8px;">
              <input id="inp-search-case" type="text" placeholder="Buscar folio, CAD o teléfono..." class="form-input" style="height:34px; font-size:0.8rem;" />
            </div>
            <div id="cases-list-container" style="flex:1; overflow-y:auto; display:flex; flex-direction:column; gap:6px; padding:8px;">
              <div style="color:var(--text-muted); font-size:0.85rem; text-align:center; padding:20px;">Cargando casos...</div>
            </div>
          </div>

          <!-- Vista Detallada del Caso Seleccionado -->
          <div id="case-detail-panel" style="display:flex; flex-direction:column; border:1px solid var(--border-dim); border-radius:8px; background:rgba(15,23,42,0.6); padding:16px; overflow-y:auto;">
            <div id="case-empty-state" style="text-align:center; color:var(--text-muted); margin:auto;">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="opacity:0.4; margin-bottom:10px;"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
              <div>Seleccione un caso de la lista para reproducir el video, revisar el chat y reconstruir la ruta GPS.</div>
            </div>
            <div id="case-content" style="display:none; flex-direction:column; gap:16px;"></div>
          </div>

        </div>
      </div>
    `;

    this.element.querySelector('#btn-close-cases-modal')?.addEventListener('click', () => this.close());
    
    const searchInp = this.element.querySelector('#inp-search-case') as HTMLInputElement;
    searchInp?.addEventListener('input', () => this.filterCases(searchInp.value.trim().toLowerCase()));

    this.setupFilterAndExportListeners();
  }

  private casesData: any[] = [];

  private async loadMetrics(): Promise<void> {
    try {
      const res = await fetch(`${this.apiBaseUrl}/api/v1/media/metrics`);
      if (res.ok) {
        const json = await res.json();
        const d = json.data;
        const setVal = (id: string, val: any) => {
          const el = this.element.querySelector(id);
          if (el) el.textContent = String(val);
        };
        setVal('#metric-total-sessions', d.totalSessions);
        setVal('#metric-completed-sessions', d.completedSessions);
        setVal('#metric-total-recs', d.totalRecordings);
        setVal('#metric-total-storage', `${d.totalStorageMb} MB`);
        setVal('#metric-total-gps', d.totalGpsPings);
      }
    } catch (_) {}
  }

  private async loadCases(): Promise<void> {
    try {
      const url = this.agencyId
        ? `${this.apiBaseUrl}/api/v1/media/cases?agencyId=${encodeURIComponent(this.agencyId)}`
        : `${this.apiBaseUrl}/api/v1/media/cases`;
      const res = await fetch(url);
      if (res.ok) {
        const json = await res.json();
        this.casesData = json.data || [];
        this.renderCasesList(this.casesData);
      }
    } catch (_) {}
  }

  private renderCasesList(cases: any[]): void {
    const container = this.element.querySelector('#cases-list-container') as HTMLElement;
    if (!container) return;

    if (cases.length === 0) {
      container.innerHTML = `<div style="color:var(--text-muted); font-size:0.85rem; text-align:center; padding:20px;">No se encontraron registros.</div>`;
      return;
    }

    container.innerHTML = cases.map((c) => `
      <div class="case-item" data-session-id="${c.sessionId}" style="padding:10px; border-radius:6px; background:rgba(255,255,255,0.03); border:1px solid rgba(255,255,255,0.06); cursor:pointer; transition:background 0.2s;">
        <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:4px;">
          <strong style="color:#38bdf8; font-size:0.85rem;">${c.incidentFolio}</strong>
          <span style="font-size:0.7rem; padding:2px 6px; border-radius:4px; ${c.status === 'COMPLETED' ? 'background:rgba(16,185,129,0.2); color:#34d399;' : 'background:rgba(245,158,11,0.2); color:#fbbf24;'}">${c.status}</span>
        </div>
        <div style="font-size:0.75rem; color:var(--text-muted);">📱 ${c.phoneNumber || 'Sin Tel.'} • 👨‍⚕️ ${c.dispatcherName}</div>
        <div style="font-size:0.72rem; color:var(--text-muted); margin-top:4px;">
          🕒 ${new Date(c.createdAt).toLocaleDateString()} ${new Date(c.createdAt).toLocaleTimeString([], { hour:'2-digit', minute:'2-digit' })}
          ${c.recordingPath ? ' • 🎥 Video Disponible' : ''}
        </div>
      </div>
    `).join('');

    container.querySelectorAll('.case-item').forEach((item) => {
      item.addEventListener('click', () => {
        const sid = item.getAttribute('data-session-id');
        const found = this.casesData.find(c => c.sessionId === sid);
        if (found) this.showCaseDetails(found);
      });
    });
  }

  private filteredCasesData: any[] = [];

  private setupFilterAndExportListeners(): void {
    const startInp = this.element.querySelector('#filter-date-start') as HTMLInputElement;
    const endInp = this.element.querySelector('#filter-date-end') as HTMLInputElement;
    const applyBtn = this.element.querySelector('#btn-apply-date-filter');
    const clearBtn = this.element.querySelector('#btn-clear-date-filter');
    const exportBtn = this.element.querySelector('#btn-export-csv');

    applyBtn?.addEventListener('click', () => {
      const sVal = startInp?.value;
      const eVal = endInp?.value;
      if (!sVal && !eVal) {
        this.renderCasesList(this.casesData);
        return;
      }

      const filtered = this.casesData.filter(c => {
        const cDate = (new Date(c.createdAt).toISOString().split('T')[0]) || '';
        if (sVal && eVal) return Boolean(cDate && cDate >= sVal && cDate <= eVal);
        if (sVal) return Boolean(cDate && cDate >= sVal);
        if (eVal) return Boolean(cDate && cDate <= eVal);
        return true;
      });

      this.filteredCasesData = filtered;
      this.renderCasesList(filtered);
    });

    clearBtn?.addEventListener('click', () => {
      if (startInp) startInp.value = '';
      if (endInp) endInp.value = '';
      this.filteredCasesData = this.casesData;
      this.renderCasesList(this.casesData);
    });

    exportBtn?.addEventListener('click', () => {
      const dataToExport = this.filteredCasesData.length > 0 ? this.filteredCasesData : this.casesData;
      if (dataToExport.length === 0) {
        alert('No hay registros para exportar en este período.');
        return;
      }

      this.exportToCsv(dataToExport);
    });
  }

  private exportToCsv(cases: any[]): void {
    const headers = [
      'Folio Incidente',
      'ID Sesión',
      'Agencia',
      'Teléfono',
      'Despachador',
      'Estatus',
      'Fecha Inicio',
      'Fecha Fin',
      'Duración (Seg)',
      'Video Disponible',
      'Mensajes Chat',
      'Puntos GPS'
    ];

    const rows = cases.map(c => [
      `"${c.incidentFolio || ''}"`,
      `"${c.sessionId || ''}"`,
      `"${c.agencyName || 'CAD-911'}"`,
      `"${c.phoneNumber || ''}"`,
      `"${c.dispatcherName || ''}"`,
      `"${c.status || ''}"`,
      `"${new Date(c.createdAt).toLocaleString()}"`,
      `"${c.endedAt ? new Date(c.endedAt).toLocaleString() : ''}"`,
      c.durationSeconds || 0,
      c.recordingPath ? 'SI' : 'NO',
      c.chatMessagesCount || 0,
      c.gpsPointsCount || 0
    ]);

    const csvContent = '\uFEFF' + [headers.join(','), ...rows.map(r => r.join(','))].join('\r\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Reporte_Llamadas_911_${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  }

  private filterCases(term: string): void {
    const base = this.filteredCasesData.length > 0 ? this.filteredCasesData : this.casesData;
    if (!term) return this.renderCasesList(base);
    const filtered = base.filter(c =>
      (c.incidentFolio && c.incidentFolio.toLowerCase().includes(term)) ||
      (c.phoneNumber && c.phoneNumber.includes(term)) ||
      (c.dispatcherName && c.dispatcherName.toLowerCase().includes(term))
    );
    this.renderCasesList(filtered);
  }

  private async showCaseDetails(caseItem: any): Promise<void> {
    const emptyState = this.element.querySelector('#case-empty-state') as HTMLElement;
    const content = this.element.querySelector('#case-content') as HTMLElement;
    if (emptyState) emptyState.style.display = 'none';
    if (!content) return;

    content.style.display = 'flex';
    content.innerHTML = `<div style="text-align:center; padding:30px; color:var(--text-muted);">Recuperando evidencia forense (chat y GPS)...</div>`;

    // Obtener detalles forenses del caso
    let forensics: any = { chat: [], gpsTracks: [] };
    try {
      const res = await fetch(`${this.apiBaseUrl}/api/v1/media/sessions/${caseItem.sessionId}/forensics`);
      if (res.ok) {
        const json = await res.json();
        forensics = json.data;
      }
    } catch (_) {}

    content.innerHTML = `
      <div style="display:flex; justify-content:space-between; align-items:center; border-bottom:1px solid var(--border-dim); padding-bottom:10px;">
        <div>
          <h4 style="font-size:1.1rem; color:#fff; margin:0;">Expediente Clínico: ${caseItem.incidentFolio}</h4>
          <span style="font-size:0.8rem; color:var(--text-muted);">ID Sesión: ${caseItem.sessionId} • Atendido por: ${caseItem.dispatcherName}</span>
        </div>
        <div style="display:flex; gap:8px;">
          <a href="${this.apiBaseUrl}/api/v1/media/sessions/${caseItem.sessionId}/zip-bundle" download class="btn-primary" 
             style="background:#059669; border-color:#059669; padding:6px 14px; font-size:0.8rem; text-decoration:none; display:inline-flex; align-items:center; gap:6px;">
            📦 Descargar Expediente (ZIP)
          </a>
          <button id="btn-popup-case-map" class="btn-primary" style="padding:6px 14px; font-size:0.8rem;">
            🗺️ Ver Ruta GPS
          </button>
        </div>
      </div>

      <!-- Video Forense -->
      <div>
        <div style="font-weight:700; font-size:0.85rem; color:#fff; margin-bottom:6px;">🎥 Grabación de Video de la Escena:</div>
        ${caseItem.recordingPath ? `
          <video controls playsinline preload="metadata" style="width:100%; max-height:340px; border-radius:8px; background:#000; border:1px solid var(--border-dim);">
            <source src="${this.apiBaseUrl}/api/v1/media/sessions/${caseItem.sessionId}/video" type="video/mp4">
            Tu navegador no soporta reproducción directa de video MP4.
          </video>
          <div style="font-size:0.75rem; color:var(--text-muted); margin-top:4px;">
            Duración: ${caseItem.durationSeconds || 0}s • Tamaño: ${Math.round((caseItem.recordingSizeBytes || 0)/1024)} KB • Códec H.264 CRF
          </div>
        ` : `
          <div style="background:rgba(255,255,255,0.03); border:1px dashed var(--border-dim); padding:16px; border-radius:8px; color:var(--text-muted); font-size:0.85rem; text-align:center;">
            No se generó grabación de video o ya fue purgada según la política de retención.
          </div>
        `}
      </div>

      <!-- Snapshots y Evidencias Fotográficas Forenses -->
      <div>
        <div style="font-weight:700; font-size:0.85rem; color:#fff; margin-bottom:6px;">📸 Evidencia Fotográfica y Anotaciones Clínicas (${forensics.snapshots?.length || 0}):</div>
        ${forensics.snapshots && forensics.snapshots.length > 0 ? `
          <div style="display:flex; gap:10px; overflow-x:auto; padding:8px 0;">
            ${forensics.snapshots.map((snap: any, idx: number) => `
              <div style="flex-shrink:0; width:140px; background:rgba(0,0,0,0.35); border:1px solid var(--border-dim); border-radius:8px; overflow:hidden;">
                <a href="${this.apiBaseUrl}${snap.url}" target="_blank" title="Clic para ampliar fotograma clínico">
                  <img src="${this.apiBaseUrl}${snap.url}" style="width:100%; height:90px; object-fit:cover; display:block;" />
                </a>
                <div style="padding:6px; font-size:0.7rem; color:var(--text-muted); text-align:center;">
                  <strong>#${idx + 1}</strong> ${snap.hasAnnotations ? '🎨 Con Guía' : '📷 Foto'}<br/>
                  ${new Date(snap.createdAt).toLocaleTimeString()}
                </div>
              </div>
            `).join('')}
          </div>
        ` : `
          <div style="color:var(--text-muted); font-size:0.8rem; background:rgba(255,255,255,0.02); padding:10px; border-radius:6px;">
            No se capturaron fotogramas en esta llamada.
          </div>
        `}
      </div>

      <!-- Chat Forense -->
      <div>
        <div style="font-weight:700; font-size:0.85rem; color:#fff; margin-bottom:6px;">💬 Historial del Chat Silencioso (${forensics.chat.length} mensajes):</div>
        <div style="max-height:180px; overflow-y:auto; background:rgba(0,0,0,0.25); border:1px solid var(--border-dim); border-radius:8px; padding:10px; display:flex; flex-direction:column; gap:6px;">
          ${forensics.chat.length > 0 ? forensics.chat.map((m: any) => `
            <div style="font-size:0.82rem; padding:6px 10px; border-radius:6px; ${m.senderRole === 'DISPATCHER' ? 'background:rgba(37,99,235,0.2); align-self:flex-start; color:#93c5fd;' : 'background:rgba(239,68,68,0.2); align-self:flex-end; color:#fca5a5;'}">
              <strong style="font-size:0.7rem; opacity:0.8;">${m.senderName} (${new Date(m.createdAt).toLocaleTimeString()}):</strong>
              <div>${m.message}</div>
            </div>
          `).join('') : '<span style="color:var(--text-muted); font-size:0.8rem;">No hubo intercambio de mensajes en esta sesión.</span>'}
        </div>
      </div>

      <!-- Puntos GPS -->
      <div>
        <div style="font-weight:700; font-size:0.85rem; color:#fff; margin-bottom:6px;">📍 Puntos de Trayectoria GPS (${forensics.gpsTracks.length} posiciones):</div>
        <div style="font-size:0.8rem; color:var(--text-muted);">
          ${forensics.gpsTracks.length > 0 ? `
            Primer punto: <strong>${forensics.gpsTracks[0].latitude.toFixed(5)}, ${forensics.gpsTracks[0].longitude.toFixed(5)}</strong> • 
            Último punto: <strong>${forensics.gpsTracks[forensics.gpsTracks.length - 1].latitude.toFixed(5)}, ${forensics.gpsTracks[forensics.gpsTracks.length - 1].longitude.toFixed(5)}</strong>
          ` : 'No se registraron coordenadas GPS durante la llamada.'}
        </div>
      </div>
    `;

    // Botón para abrir el mapa histórico en ventana emergente independiente
    this.element.querySelector('#btn-popup-case-map')?.addEventListener('click', () => {
      this.openHistoricMapPopup(caseItem, forensics.gpsTracks);
    });
  }

  private openHistoricMapPopup(caseItem: any, tracks: any[]): void {
    if (!tracks || tracks.length === 0) {
      alert('Este caso no tiene coordenadas GPS registradas.');
      return;
    }

    const popup = window.open('', 'SOS_Historic_Map', 'width=1000,height=750,resizable=yes');
    if (!popup) {
      alert('Permita popups en el navegador.');
      return;
    }

    const center = [tracks[0].latitude, tracks[0].longitude];
    const pathCoords = tracks.map(t => [t.latitude, t.longitude]);

    popup.document.write(`
      <!DOCTYPE html>
      <html lang="es">
      <head>
        <meta charset="UTF-8">
        <title>Ruta GPS Caso ${caseItem.incidentFolio}</title>
        <link rel="stylesheet" href="https://unpkg.com/leaflet@1.9.4/dist/leaflet.css" />
        <style>
          body, html { margin:0; padding:0; height:100%; background:#0f172a; font-family:sans-serif; }
          #map { width:100%; height:100%; }
          .badge { position:absolute; top:16px; left:16px; z-index:1000; background:rgba(15,23,42,0.9); color:#fff; padding:10px 16px; border-radius:8px; border:1px solid #334155; }
        </style>
      </head>
      <body>
        <div class="badge">
          <strong>Folio: ${caseItem.incidentFolio}</strong><br/>
          <small>Puntos registrados: ${tracks.length} | Despachador: ${caseItem.dispatcherName}</small>
        </div>
        <div id="map"></div>
        <script src="https://unpkg.com/leaflet@1.9.4/dist/leaflet.js"></script>
        <script>
          const map = L.map('map').setView([${center[0]}, ${center[1]}], 16);
          L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19 }).addTo(map);
          const path = L.polyline(${JSON.stringify(pathCoords)}, { color: '#ef4444', weight: 4 }).addTo(map);
          L.marker([${tracks[0].latitude}, ${tracks[0].longitude}]).addTo(map).bindPopup('Inicio de llamada').openPopup();
          if (${tracks.length} > 1) {
            L.marker([${tracks[tracks.length - 1].latitude}, ${tracks[tracks.length - 1].longitude}]).addTo(map).bindPopup('Fin de llamada');
          }
          map.fitBounds(path.getBounds());
        </script>
      </body>
      </html>
    `);
    popup.document.close();
  }

  public close(): void {
    this.element.remove();
    this.onClose();
  }
}
